import loadable from '@loadable/component';

import './Page.css';

export default loadable(() => {
  return import('./Page.jsx');
});
